import { render, staticRenderFns } from "./PromocodePreview.vue?vue&type=template&id=6b9c4a14&scoped=true"
import script from "./PromocodePreview.vue?vue&type=script&lang=js"
export * from "./PromocodePreview.vue?vue&type=script&lang=js"
import style0 from "./PromocodePreview.vue?vue&type=style&index=0&id=6b9c4a14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9c4a14",
  null
  
)

export default component.exports